import React from 'react';
import RightGreenCheckMark from '../../../assets/images/right-green-check-mark.svg';

const SuccessSection: React.FC = () => {
  return (
    <div className="success-root">
      <img src={RightGreenCheckMark} alt="Checkmark" />
      <h6>Thank you for interest.</h6>
      <p>A WaveXchange representative will reach out to you shortly.</p>
    </div>
  );
};

export default SuccessSection;
